import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import Text from 'components/Text';
import { Select, Option } from 'components/Select';
import Flex from 'components/Flex';
import VisuallyHidden from 'components/VisuallyHidden';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var dateWithYearOptions = {
  options: {
    month: 'short',
    year: 'numeric',
    day: 'numeric'
  },
  isInLocalTimezone: false,
  fallbackVariant: 'hyphen'
};
var dateWithoutYearOptions = {
  options: {
    month: 'short',
    year: undefined,
    day: 'numeric'
  },
  isInLocalTimezone: false,
  fallbackVariant: 'hyphen'
};
function WeeksDropdown(_ref) {
  var selected = _ref.selected,
    weekDates = _ref.weekDates,
    onChange = _ref.onChange,
    _ref$filterLabelId = _ref.filterLabelId,
    filterLabelId = _ref$filterLabelId === void 0 ? 'week-commencing-filter' : _ref$filterLabelId;
  return /*#__PURE__*/_jsx(Select, {
    labelledById: filterLabelId,
    size: "medium",
    menuPlacement: "bottom",
    value: selected,
    onChange: onChange,
    variant: "transparent",
    ml: "-xxs",
    children: weekDates.map(function (weekCommencing) {
      var endDateString = new Date(new Date(weekCommencing).setDate(new Date(weekCommencing).getDate() + 6)).toISOString();
      var haveSameYear = weekCommencing.slice(0, 4) === endDateString.slice(0, 4);
      var startDate = getLocalisedDate(_objectSpread({
        date: weekCommencing
      }, haveSameYear ? dateWithoutYearOptions : dateWithYearOptions)) || '';
      var endDate = getLocalisedDate(_objectSpread({
        date: endDateString
      }, dateWithYearOptions)) || '';
      var dateRange = "".concat(startDate, " - ").concat(endDate);
      return /*#__PURE__*/_jsx(Option, {
        value: weekCommencing,
        children: dateRange
      }, weekCommencing);
    })
  });
}
function WeekFilter(_ref2) {
  var selected = _ref2.selected,
    weekDates = _ref2.weekDates,
    onChange = _ref2.onChange,
    _ref2$showTitle = _ref2.showTitle,
    showTitle = _ref2$showTitle === void 0 ? true : _ref2$showTitle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var filterLabelId = 'week-filter';
  if (!showTitle) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(VisuallyHidden, {
        id: filterLabelId,
        children: t('form_week_colon')
      }), /*#__PURE__*/_jsx(WeeksDropdown, {
        selected: selected,
        weekDates: weekDates,
        onChange: onChange,
        filterLabelId: filterLabelId
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "xxs",
    children: [/*#__PURE__*/_jsx(Text, {
      id: filterLabelId,
      bold: true,
      children: t('form_week_colon')
    }), /*#__PURE__*/_jsx(WeeksDropdown, {
      selected: selected,
      weekDates: weekDates,
      onChange: onChange,
      filterLabelId: filterLabelId
    })]
  });
}
export default WeekFilter;